import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import classes from './ProfileDetails.module.css';
import { useParams } from 'react-router-dom';
import Gallery from '../../components/Gallery/Gallery';
import MainLayout from '../../components/layout/MainLayout';
import Memorial from '../../components/Memorial/Memorial';
import MemoryList from '../../components/MemoryList/MemoryList';
import ProfileCover from '../../components/ProfileCover/ProfileCover';
import ProfileDescription from '../../components/ProfileDescription/ProfileDescription';
import ProfileInfo from '../../components/ProfileInfo/ProfileInfo';
import ProfileLifeAxis from '../../components/ProfileLifeAxis/ProfileLifeAxis';
import ProfileNavigator from '../../components/ProfileNavigator/ProfileNavigator';
import WallFriend from '../../components/WallFriend/WallFriend';
import { useSelector, useDispatch } from 'react-redux';
import { getProfile } from '../../features/profile/profileSlice';
import Loader from '../../components/Loader/Loader';
import { getProfileMemories } from '../../features/memory/memorySlice';
import { useState } from 'react';
import PhysicalQrModal from '../../modals/PhysicalQrModal';
import SocialFooter from '../../components/SocialFooter/SocialFooter';
import VirtualMemory from '../../components/VirtualMemory/VirtualMemory';
import GalleryGrid from '../../components/Gallery/GalleryGrid';
import { Helmet } from 'react-helmet-async';
import emailTextAndSubject from '../../utils/emailTextAndSubject';
import { createNotification } from '../../features/notification/notificationSlice';
import CreateMemoryModal from '../../modals/CreateMemoryModal';
import MemorialDayModal from '../../modals/MemorialDayModal';
import FacebookShareModal from '../../modals/FacebookShareModal';
import CFNotificationModal from '../../modals/CFNotificationModal';
import { getCandlesFlowers } from '../../features/candleFlower/candleFlowerSlice';
import CFWidget from '../../components/CFWidget/CFWidget';
import { createProfileVisit } from '../../features/profile/profileSlice';
import moment from "moment";

const ProfileDetails = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
          if(window.location.hash) {
            // window.history.replaceState("", document.title, window.location.pathname);
            }
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change
  
  
  /* Hide or Show section according to the state value */
  const [showSection, setShowSection] = useState('wall');
  const dispatch = useDispatch();
  /* Profile Id (Getting from URL) */
  var { profileId } = useParams();

  // e.s. convert emergency profileid to profileid
  // 26/12/2025
  let matrix = {
    "6847ec7d5a3bc129a0dc381f": "67518dab118d782d480fad4e" , 
    "66379f63911e2c7a3a0cbe5a": "661e8e0c690bfe0048e0d9b6" , // THIS TEST FOR DEV SERVER
    "6847ed455a3bc129a0dc39a0": "67518f0a118d782d480fc111",
    "6847f05f5a3bc129a0dc3f4a": "6750349a118d782d480eac78",
    "6847ff8b5a3bc129a0dc4d5e": "675034cd118d782d480eb04d",
    "6847eb635a3bc129a0dc3672": "675034e3118d782d480eb107",
    "6847f1175a3bc129a0dc412c": "67503460118d782d480ea643",
    "6847fef95a3bc129a0dc4a2a": "67503449118d782d480ea47e",
    "6847eca45a3bc129a0dc3868": "67503429118d782d480ea081",
    "6847ee975a3bc129a0dc3c84": "67519249118d782d480fdc28",
    "6847f0f95a3bc129a0dc40bb": "6751921f118d782d480fd802",
    "6847ebf75a3bc129a0dc3776": "67518db9118d782d480fae9b",
    "6847fd825a3bc129a0dc437d": "67518dc9118d782d480fafe8",
    "6847fedf5a3bc129a0dc499b": "6751923b118d782d480fdad6",
    "6847eb7f5a3bc129a0dc36b3": "6751922e118d782d480fd989",
    "6847ef285a3bc129a0dc3e2d": "67503fda118d782d480ef434",
    "6847e73d5a3bc129a0dc325b": "6750355d118d782d480ebad2",
    "6847eeb45a3bc129a0dc3ce7": "67518eed118d782d480fbe77",
    "6847fe785a3bc129a0dc477b": "67518efc118d782d480fbfc4",
    "6847e9ac5a3bc129a0dc3347": "67518edd118d782d480fbd2a",
    "6847fdcf5a3bc129a0dc446f": "67519280118d782d480fe15c",
    "6847ff5f5a3bc129a0dc4c2e": "67518d7a118d782d480fa967",
    "6847edf95a3bc129a0dc3ab1": "67518d69118d782d480fa81a",

    "6847eac35a3bc129a0dc35c7": "67518d59118d782d480fa6cd",
    "6847ed275a3bc129a0dc394f": "67518d28118d782d480fa433",
    "6847ef075a3bc129a0dc3dc4": "67518d18118d782d480fa2e6",
    "6847fe3b5a3bc129a0dc466f": "67518d08118d782d480fa199",
    "6847edb95a3bc129a0dc3a5a": "67518cf7118d782d480fa04c",
    "6847f0885a3bc129a0dc3fb9": "67518f64118d782d480fc56e",
    "6847ee545a3bc129a0dc3bc2": "67518f20118d782d480fc25e",
    "6847ff4a5a3bc129a0dc4b99": "67518f3a118d782d480fc3ab",
    "6847ebbe5a3bc129a0dc3733": "67504110118d782d480f177f",
    "6847e9f65a3bc129a0dc3397": "67519263118d782d480fdec2",
    "6847fe035a3bc129a0dc456b": "67519256118d782d480fdd75",
    "6847e97b5a3bc129a0dc331a": "675040dc118d782d480f0f3d",
    "6847fe8f5a3bc129a0dc4804": "675040cb118d782d480f0ccc",
    "6847fda75a3bc129a0dc43f4": "675040b8118d782d480f0ba2",
    "6847fe5b5a3bc129a0dc46f4": "675040a7118d782d480f0a7f",
    "6847fe1c5a3bc129a0dc45ec": "6750401e118d782d480efcec",
    "6847e94a5a3bc129a0dc32ef": "67503fec118d782d480ef641",
    "6847e6e75a3bc129a0dc322c": "67503c9c118d782d480ebf70",
    "6847eb475a3bc129a0dc3637": "6750358f118d782d480ebd3c",
    "6847ff795a3bc129a0dc4cc5": "67518ce6118d782d480f9eff",
    "6847eba35a3bc129a0dc36f2": "6847eba35a3bc129a0dc36f2",
    "6847fde55a3bc129a0dc44ec": "6750343a118d782d480ea2c0",
    "6847ed6d5a3bc129a0dc39f3": "67518eb2118d782d480fbbce",
    "6847eed35a3bc129a0dc3d54": "67518e9e118d782d480fba7c",
    "6847ec295a3bc129a0dc37d8": "67518c8f118d782d480f9b0e",
    "6847feab5a3bc129a0dc488f": "6751928f118d782d480fe2a9",
    "6847ee6f5a3bc129a0dc3c23": "675035a3118d782d480ebdea",
    
  };
  
  if ( profileId in matrix ) {
    let old=profileId;
    profileId = matrix[profileId]; 
    console.log("e.s. redirect",{old,profileId});
  }
  


  /* Redux State */
  const { profile } = useSelector((state) => state.profile);
  const { user } = useSelector((state) => state.user);
  const { memories } = useSelector((state) => state.memory);
  /* Get the profile details accordion to the profile id */
  useEffect(() => {
    dispatch(getProfile(profileId));
  }, [dispatch, profileId]);
  /* Get all memories of that profile */
  useEffect(() => {
    dispatch(getProfileMemories(profileId));
  }, [dispatch, profileId]);
  /* Get candles and flowers for profile */
  useEffect(() => {
    dispatch(getCandlesFlowers(profileId));
  }, [dispatch, profileId]);
  useEffect(() => {
    if (!profile._id || !user._id) return;
    const receivers = [
      ...profile.profileAdmins
        .filter((admin) => admin._id !== user._id)
        .map((admin) => admin._id),
    ];
    if (profile.originalUser._id !== user._id)
      receivers.push(profile.originalUser._id);

    const notification = {
      ...emailTextAndSubject(
        'profileVisit',
        {
          organizationName: profile.organizationName,
          firstName: profile.firstName,
          lastName: profile.lastName,
        },
        {
          organizationName: user.organizationName,
          firstName: user.firstName,
          lastName: user.lastName,
        }
      ),
      creator: user._id,
      receivers: receivers,
      url: window.location.href,
    };
    // dispatch(createNotification(notification)); //TODO: Server notifications
    
    
    const visitKey = `lastVisit${profile._id}`;
    
    if(!localStorage.getItem(visitKey))
    {
          dispatch(createProfileVisit(profile._id));
          localStorage.setItem(`lastVisit${profile._id}`,moment().toISOString());
    }
    else
    {
      const now = moment();
      const lastTime=moment(localStorage.getItem(visitKey));
      if((now.diff(lastTime,'hours')>=24))
      {
          dispatch(createProfileVisit(profile._id));
          localStorage.setItem(`lastVisit${profile._id}`,moment().toISOString());
      }
    }
 
     
     
  }, [dispatch, profile, user]);
  /* If profile not loaded then loading spinner will show */
  if (!profile._id) return <Loader />;
  /* Check if the current login user is the owner or admin of visited profile */
  const isOwnerOrAdmin =
    profile.originalUser._id === user._id ||
    profile.profileAdmins.find((admin) => admin._id === user._id);
  const isFriend = profile.profileFriends.find(
    (friend) => friend._id === user._id
  );
  const pUrl = `${window.location.protocol}//${window.location.host}/profile/${profileId}`;
  return (
    <React.Fragment>
      <Helmet>
        <title>
          LifeCloud | {profile.firstName} {profile.lastName} ז"ל
        </title>
        <meta
          name="description"
          content={`זה הוא סיפור החיים של ${profile.firstName}, הכל התחיל בשנת ${profile.birthYear} והתרחש ב${profile.city}. בעמוד תוכלו למצוא תמונות וזכרונות מהחיים ששותפו על ידי המשפחה וחברים. אירועים ואזכרה.`}
        />
        <meta
          property="og:url"
          content={`https://lifecloud-qr.com/profile/${profileId}`}
        />
        <meta
          property="og:title"
          content={`זוכרים את ${profile.firstName} ${profile.lastName} | Lifecloud-qr.com`}
        />
        <meta
          property="og:description"
          content={`הכנסו לחלוק כבוד ל ${profile.firstName}, סיפור החיים של ${profile.firstName} התחיל בשנת ${profile.birthYear} והתרחש ב${profile.city}. בעמוד תוכלו למצוא תמונות וזכרונות ששותפו על ידי המשפחה וחברים. אירועים ואזכרה.`}
        />
        <meta property="og:image" content={profile.wallImg} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <link rel="canonical" href={pUrl} />
      </Helmet>
      <MainLayout bg="#fff" footerClassName={classes.footer}>
        <ProfileCover
        isOwnerOrAdmin={isOwnerOrAdmin}
          profileId={profile._id}
          wallImg={profile.wallImg}
          objectYPos={profile.objectYPos}
        />
        <ProfileInfo profile={profile} />
        <ProfileNavigator
          showSection={showSection}
          setShowSection={setShowSection}
          isFriend={isFriend}
          isOwnerOrAdmin={isOwnerOrAdmin}
          profile={profile}
          user={user}
        />
        {(profile.privacy === 'public' || isOwnerOrAdmin || isFriend) && (
          <React.Fragment>
            {showSection === 'gallery' && (
              <GalleryGrid
                gallery={profile.gallery}
                //galleryProperties={profile.galleryProperties}
                setShowSection={setShowSection}
              />
            )}
            {showSection === 'wall' && (
              <React.Fragment>
                <Memorial
                  profile={profile}
                  isOwnerOrAdmin={isOwnerOrAdmin}
                  isFriend={isFriend}
                />
                <ProfileDescription description={profile.description} />
                <ProfileLifeAxis profile={profile} />
                <Gallery
                  gallery={profile.gallery}
                  //galleryProperties={profile.galleryProperties}
                  setShowSection={setShowSection}
                />

                <MemoryList
                  memories={memories}
                  profileId={profileId}
                  isOwnerOrAdmin={isOwnerOrAdmin}
                  isFriend={isFriend}
                />

                <VirtualMemory
                  profileId={profile._id}
                  profileImg={profile.profileImg}
                />
              </React.Fragment>
         
            )}

            {showSection === 'wallFriend' && (
              <WallFriend
                profile={profile}
                setShowSection={setShowSection}
                user={user}
                isOwnerOrAdmin={isOwnerOrAdmin}
              />
            )}
          </React.Fragment>
        )}
        <SocialFooter cloudPos="down-right" />
        <PhysicalQrModal user={user} profile={profile} />
        {/*
        <CreateMemoryModal profileId={profileId} />
        */}
        <CFWidget />
        <MemorialDayModal profile={profile} isOwnerOrAdmin={isOwnerOrAdmin} />
        <CFNotificationModal profileId={profileId} userId={user._id} />
        <FacebookShareModal />
      </MainLayout>
    </React.Fragment>
  );
};

export default ProfileDetails;
